// DriverSidebar.jsx
import NestedMenu from "components/Shared/NestedMenu";
import DownloadTMSDriverCard from "components/Shared/UI/DownloadTMSDriverCard";
import React from "react";

const DriverSidebar = () => {
  const menuItems = [
    {
      title: "Dashboard",
      path: "/app/driver/dashboard",
      icon: "DashboardOutlined",
    },
    { title: "Profile", path: "/app/driver/profile", icon: "PersonOutlined" },
    { title: "Licences", path: "/app/driver/licence", icon: "ArticleOutlined" },
    {
      title: "Schedules",
      path: "/app/driver/schedule",
      icon: "DateRangeOutlined",
    },
    {
      title: "My Collections",
      path: "/app/driver/myShipments",
      icon: "CategoryOutlined",
    },
    { title: "Loading", path: "/app/driver/loading", icon: "LocalShipping" },
    {
      title: "Unloading",
      path: "/app/driver/unloading",
      icon: "LocalShippingOutlined",
    },
    { title: "Send Out", path: "/app/driver/sendOut", icon: "Send" },
    { title: "Pending Delivery", path: "/app/driver/pendingDelivery", icon: "PendingActions" },
    { title: "Delivery", path: "/app/driver/delivery", icon: "LocalShippingOutlined" },
    { title: "Load Transfer", path: "/app/driver/transfer-driver", icon: "DepartureBoardOutlined" },
    { title: "Partial Load Transfer", path: "/app/driver/partial-transfer-driver", icon: "DepartureBoardOutlined" },
    { title: "QR Load Transfer", path: "/app/driver/qr-transfer-driver", icon: "DepartureBoardOutlined" },
  ];
  return (
    <>
      <NestedMenu menu={menuItems} initiallyOpenedMenu="Males" />
      <DownloadTMSDriverCard />
    </>
  );
};

export default DriverSidebar;
